import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface RepaymentMonthly {
  month: string;
  label: string;
  expected: number;
  received: number;
  variance: number;
  collectionRate: number;
}

export interface RepaymentTotals {
  totalExpected: number;
  totalReceived: number;
  overallCollectionRate: number;
}

export interface RepaymentPerLoan {
  loanId: string;
  loanNumber: string;
  borrowerName: string;
  expectedThisMonth: number;
  receivedThisMonth: number;
  status: 'ON_TRACK' | 'PARTIAL' | 'MISSED' | 'AHEAD';
}

export interface RepaymentTrackerData {
  monthly: RepaymentMonthly[];
  totals: RepaymentTotals;
  perLoan: RepaymentPerLoan[];
}

export function useRepaymentTracker(months = 6) {
  return useQuery<RepaymentTrackerData>({
    queryKey: ['repayment-tracker', months],
    queryFn: async () => {
      const { data } = await api.get('/reports/repayment-tracker', { params: { months } });
      return data;
    },
    staleTime: 5 * 60_000,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  });
}
